module.exports = new __parcel__URL__("stained-glass-2.c411fa5a.webp").toString();